import React from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Button, Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Logo from "./Logo";
import { onMobileNavToggle, toggleCollapsedNav } from "../../redux/actions/Theme";
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from "constants/ThemeConstant";
import utils from "utils";
import { useTranslation } from "react-i18next";
import { logoutFromBothFirebase } from "../../configs/FirebaseConfig";
import { useAuth } from "../../data/hooks/useAuth";

const { Header } = Layout;

export const HeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    // onMobileNavToggle,
    isMobile,
    currentTheme,
  } = props;
  const { t } = useTranslation();
  const { email } = useAuth();
  const dispatch = useDispatch();

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      dispatch(onMobileNavToggle(!mobileNav));
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(currentTheme === "dark" ? "#00000" : "#ffffff");
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  const handleSignOut = async (e) => {
    e.preventDefault();
    try {
      await logoutFromBothFirebase();
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  return (
    <Header className={`app-header ${navMode}`} style={{ backgroundColor: "#FFF" }}>
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo logoType={navMode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            {isNavTop && !isMobile ? null : navCollapsed || isMobile ? (
              <MenuUnfoldOutlined
                className="nav-icon"
                onClick={() => {
                  onToggle();
                }}
              />
            ) : (
              <MenuFoldOutlined
                className="nav-icon"
                onClick={() => {
                  onToggle();
                }}
              />
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: "1rem" }}>{email}</span>
            <Button onClick={(e) => handleSignOut(e)}>{t("logout")}</Button>
          </div>
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav, currentTheme } = theme;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
  };
};

export default connect(mapStateToProps, { toggleCollapsedNav, onMobileNavToggle })(HeaderNav);
